<template>
  <div class="section-bills-list section-merge" @scroll="onScroll($event)">
    <div class="col-8 col-lg-8 col-xl-5 mx-auto py-xl-2">
      <h3 class="ttl2 popup-header" v-translate>choose bill to merge</h3>
      <bills-table
        :bills="bills"
        :firstBill="firstBill"
        :secondBill="secondBill"
        :openOnly="true"
        @billClicked="setSecondBill"
      />
      <div class="popup-action btn-confirm-undo" :style="{'top': scrollTop}">
        <div>
          <translate>bills to merge</translate>:
          <span class="bill-no" v-if="firstBill">
            <translate>No.</translate>
            {{firstBill.number}}
          </span>
          &
          <span class="bill-no" v-if="secondBill">
            <translate>No.</translate>
            {{secondBill.number}}
          </span>
        </div>
        <button type="button" class="btn btn-confirm" @click="save()" v-translate>confirm</button>
      </div>
    </div>
  </div>
</template>

<script>
import { TOGGLE_BILL_MODAL_VISIBLE, SET_MESSAGE_MODAL } from "@/store/mutation-types";
import BillsTable from "@/components/BillsTable.vue";
import BillService from "@/services/BillService";

export default {
  name: "MergeBill",
  props: ["firstBill"],
  components: {
    BillsTable
  },
  data() {
    return {
      secondBill: {},
      scrollTop: 0
    };
  },
  computed: {
    bills() {
      return this.getArray("bills")
        .filter(bill => bill.status == this.OPEN_STATUS)
        .reverse();
    }
  },
  methods: {
    setSecondBill(bill) {
      if (this.firstBill.id == bill.id) return;
      this.secondBill = bill;
    },
    onScroll(event) {
      this.scrollTop = `${event.target.scrollTop}px`;
    },
    async save() {
      if (this.secondBill && this.secondBill.id) {
        if (!this.secondBill.payDetails) {
          const result = await BillService.getBill(this.secondBill.id);
          if (result) {
            this.secondBill = result;
          }
        }
        const billItems = this.$store.state.bill.previousOrder.concat(
          this.secondBill.billItems
        );
        const response = await BillService.mergeBill(
          this.firstBill,
          this.secondBill,
          billItems
        );
        if (response) {
          this.$store.state.bill.billModal = "new";
          await this.$store.dispatch('setBill', response.insert);
        }
      } else {
        this.$store.commit(
          SET_MESSAGE_MODAL,
          this.$gettext("Please choose second bill to merge")
        );
      }
    }
  },
  async created() {
    if (!this.firstBill) {
      this.$router.push("order");
    }
  }
};
</script>
